import { createFileRoute } from '@tanstack/react-router'
import TrainingVirtualDetailPage from '@/pages/resources/trainings-virtual/detail'

export const Route = createFileRoute('/app/resources/trainings-virtual/$id')({
  component: RouteComponent,
})

function RouteComponent() {
  const { id } = Route.useParams()
  return <TrainingVirtualDetailPage id={Number(id)} />
}
